import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class UserConfigServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getItem(user_id) {
    return this.http.get(`${user_id}/profiles`);
  }

  editItem(user_id, params = {}) {
    return this.http.put(`${user_id}/profiles`, params);
  }
}

export const UserConfigService = new UserConfigServiceClass({
  api_version: 2,
  resource: 'users'
});
